import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const actions = {
  init({ state, dispatch }) {},
  paylessOrderDetail(context, ctx) {
    return axios
      .get(`${serverUrl}/euro_payless/order_detail/order_detail/?barcode=${ctx.qr}&store_code=${ctx.store_code}`)
      .then((response) => {
        return response.data
      })
  },
  paylessAuthorizeOrder(context, data) {
    return axios
      .post(`${serverUrl}/euro_payless/authorize/`, data)
      .then((response) => {
        return response.data
      })
  },
  fetchLogsPayless(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_payless/logs_payless/get_logs/${query}`).then((response) => {
      return response.data
    })
  },
  fetchPaylessReport(context, payload) {
    return axios.get(`${serverUrl}/euro_payless/logs_payless/payless_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },
  
}